import { isValid } from './utils';

// ArticleCard
export const TOP_CARD = "top-card";
export const BIG_CARD = "big-card";
export const FEATURED_CARD = "featured-card";
export const SMALL_CARD = "small-card";

// ImageModule
const HERO_IMAGE = 'hero-image';
const LARGE_IMAGE = 'large-image';
const FULL_WIDTH_IMAGE = 'full-width-image';
const TWO_IMAGE = 'two-image';

const CARDS = {
	[TOP_CARD]: {
		cssClass: TOP_CARD,
		widthMobile: 1.0,
		widthNonMobile: 1200,
		fit: "clip",
		useImgixDPR: true,
	},
	[BIG_CARD]: {
		cssClass: BIG_CARD,
		widthMobile: 710,
		widthNonMobile: 300,
		fit: "clip",
		useImgixDPR: false,
	},
	[SMALL_CARD]: {
		cssClass: SMALL_CARD,
		widthMobile: 320,
		widthNonMobile: 300,
		fit: "clip",
		useImgixDPR: false,
	},
	[FEATURED_CARD]: {
		cssClass: FEATURED_CARD,
		widthMobile: 640,
		widthNonMobile: 640,
		fit: "clip",
		useImgixDPR: false, 
	},
};

const IMAGES = {
	[HERO_IMAGE]: {
		cssClass: HERO_IMAGE,
		widthMobile: 1.0,
		widthNonMobile: 1600,
		fit: 'clip',
		useImgixDPR: true,
	},
	[LARGE_IMAGE]: {
		cssClass: LARGE_IMAGE,
		widthMobile: 750,
		widthNonMobile: 636,
		fit: 'clip',
		useImgixDPR: true,
	},
	[FULL_WIDTH_IMAGE]: {
		cssClass: FULL_WIDTH_IMAGE,
		widthMobile: 1.0,
		widthNonMobile: 1600,
		fit: 'clip',
		useImgixDPR: true,
	},
	[TWO_IMAGE]: {
		cssClass: TWO_IMAGE,
		widthMobile: 375,
		widthNonMobile: 646,
		fit: 'clip',
		useImgixDPR: true,
	},
};

export const createImgixURL = (imgUrl, width, fit = 'clip', useImgixDPR = false, height = "") => {
  const BASE_IMGIX_PARAMS = 'ch=Width,DPR&auto=compress&q=60';
  const IMGIX_DPR = 2;
  const MOBILE_HERO_WIDTH_TO_HEIGHT = 1.083;
  const DESKTOP_WIDTH_TO_HEIGHT = 1.82;

  if (fit === "crop") {
    height = `&h=${height === "" ? width * MOBILE_HERO_WIDTH_TO_HEIGHT : height}`;
  }
  if (fit === "landerCrop") {
    fit = "crop";
    height = `&h=${height === "" ? width / DESKTOP_WIDTH_TO_HEIGHT : height}`;
  }

  return `${imgUrl}?${BASE_IMGIX_PARAMS}&w=${width}&fit=${fit}${height}${useImgixDPR ? `&dpr=${IMGIX_DPR}` : ''}`;
};

export const determineCardType = (i, isFeatured = false, bigCardOnly = false, excludeTopCard = false) => {
  let cardType = FEATURED_CARD;
  let cardStyleNum = Math.floor((i - 4) / 3);

  if (!isFeatured) {
	cardType = i <= 3? TOP_CARD : (cardStyleNum % 2 === 0) ? BIG_CARD : SMALL_CARD;	
  }

  //handles case where all cards are big cards except the first one which is a top card (ex. roster)
  if (bigCardOnly) {
  	cardType = BIG_CARD;
  }

  // handles case where all cards are big cards including the first one (ex. featured content)
  if (bigCardOnly && i === 0 && !excludeTopCard) {
  	cardType = TOP_CARD;
  }

  return cardType;
}

export const setCardImage = (data, isMobile) => {
	const { cardClass, categoryImage } = data;
	const { topcardMobile=null, topcard=null, bigcard=null, smallcard=null, card=null, featurecardMobile=null, featurecard=null} = categoryImage;
	const cssClass = `article-card ${cardClass}`;
	let imageSrc = card;

	switch(cardClass) {
		case TOP_CARD:
		imageSrc = (isMobile && isValid(topcardMobile)) ? topcardMobile : isValid(topcard) ? topcard : card;
		break;

		case BIG_CARD:
		imageSrc = isValid(bigcard) ? bigcard : card;
		break;

		case FEATURED_CARD:
		imageSrc = (isMobile && isValid(featurecardMobile)) ? featurecardMobile : isValid(featurecard) ? featurecard : card;
		break;
	}
	return imageSrc;
}

export const appendImgixParamsLander = (data, isMobile) => {
	const { cardClass, imageSrc, imageSrcHero, imageSrcHeroMobile } = data;
	const card = CARDS[cardClass];
	const { widthNonMobile, useImgixDPR } = card;
	const widthMobile = (cardClass === TOP_CARD && typeof window !== "undefined") ? window.innerWidth : card.widthMobile;
	const imageWidth = isMobile ? widthMobile : widthNonMobile;
	const cssClass = `article-card ${cardClass}`;
	let { fit } = card;
	let cardImageSrc = imageSrc || imageSrcHero;

	if (cardClass === TOP_CARD) {
		cardImageSrc = isMobile ? (imageSrcHeroMobile || imageSrcHero) : imageSrcHero;
		if (isMobile && !imageSrcHeroMobile) {
			fit = "crop";
		}
	}

	if (cardClass === BIG_CARD || cardClass === SMALL_CARD) {
		if (!isMobile && !imageSrc) {
			fit = "landerCrop";
		}
	}

	return createImgixURL(cardImageSrc, imageWidth, fit, useImgixDPR);
}

export const appendImgixParamsArticle = (data, isMobile, slotClass) => {
	const { imageSrc, imageSrcMobile } = data;
	
	if (imageSrc === null && imageSrcMobile === null) {
		return null;
	}

	const slot = IMAGES[slotClass];
	const { widthNonMobile, useImgixDPR } = slot;
	const widthMobile = ((slotClass === HERO_IMAGE || slotClass === FULL_WIDTH_IMAGE) && typeof window !== "undefined") ? window.innerWidth : slot.widthMobile;
	const imageWidth = isMobile ? widthMobile : widthNonMobile;
	let { fit } = slot;
	let slotImageSrc = (isMobile && imageSrcMobile) ? imageSrcMobile : imageSrc;

	if (slotClass === HERO_IMAGE && isMobile && imageSrcMobile === null) {
		fit = 'crop';
	}

	return createImgixURL(slotImageSrc, imageWidth, fit, useImgixDPR);	
}
